//@flow -strict
import { AssetAiDataWebclient, BoundingBoxCoordinates, Point, ValueList } from '../../autogenerated/ZoomBridge';
import { AssetAiData, BoundingBox, TimeCode } from './AssetAiData';

export default class AssetAiDataModel {
  _groupName2DocumentIds: Map<string, Array<string>>;
  _idToAssetAiData: Map<string, AssetAiData>;
  _cachedGroupNames: Array<string>; //Populated lazily..

  constructor(assetAiData: AssetAiDataWebclient[], groupNameToDocumentIds: Map<string, Array<string>>) {
    const groupByClass: GroupByClass = new GroupByClass(assetAiData);
    this._idToAssetAiData = groupByClass._idToAssetAiData;
    this._groupName2DocumentIds = groupNameToDocumentIds;
  }

  get groupName2DocumentIds() {
    return this._groupName2DocumentIds;
  }
  /**
   * Return all the groups for this ai metadata....
   */
  getGroupNames(): Array<string> {
    if (!this._cachedGroupNames) {
      this._cachedGroupNames = [...this._groupName2DocumentIds.keys()];
      this._cachedGroupNames = this._cachedGroupNames.sort();
    }
    return this._cachedGroupNames;
  }

  /**
   * Returns the ai data document ids for given group name...
   * @param {string} groupName
   */
  getAiDataIdsForGroupName(groupName: string): Array<string> {
    //face => [..... uuids]
    let ids: ?Array<string> = this._groupName2DocumentIds.get(groupName);
    if (ids) {
      return ids;
    }
    return [];
  }

  getAssetAiData(id: string): AssetAiData {
    return this._idToAssetAiData.get(id);
    //const assetIdDataModel = this._idToAssetAiData.get(id);
  }

  getAllDocumentIds(): Array<string> {
    return [...this._idToAssetAiData.keys()];
  }
}

export class AssetAiDataImpl extends AssetAiData {
  _assetAiDataModel: AssetAiDataWebclient;
  _properties: ?Map<string, string>;
  _boundingBoxes: Array<BoundingBox>;
  _timecode: ?TimeCode;

  constructor(assetAiDataModel: AssetAiDataWebclient) {
    super();
    this._assetAiDataModel = assetAiDataModel;
    const properties = new Map();

    if (!!this._assetAiDataModel.getProperties() === true) {
      this._assetAiDataModel.getProperties().forEach(function(key: string, values: ValueList) {
        properties.set(key, values.getValues().join(', '));
      });
    }
    this._properties = properties;

    const boundingBoxCoordinates: Array<BoundingBoxCoordinates> = this._assetAiDataModel.getBoundingBox();
    if (boundingBoxCoordinates != null) {
      this._boundingBoxes = [];
      for (let index = 0; index < boundingBoxCoordinates.length; index++) {
        const element: BoundingBoxCoordinates = boundingBoxCoordinates[index];
        this._boundingBoxes.push(new BoundingBoxImpl(element.getPoints()));
      }
    }
    if (assetAiDataModel.getTimeCode()) {
      this._timecode = new TimeCode(
        assetAiDataModel.getTimeCode().getStartTime(),
        assetAiDataModel.getTimeCode().getEndTime()
      );
    }
  }

  getUuid(): string {
    return this._assetAiDataModel.getUuid();
  }

  getProperties(): ?Map<string, string> {
    return this._properties;
  }

  getValue(): ?string {
    return this._assetAiDataModel.getValue();
  }
  getConfidence(): number {
    return Math.floor(this._assetAiDataModel.getConfidence() / 100);
  }
  getBoundingBox(): Array<BoundingBox> {
    return this._boundingBoxes;
  }

  getTimeCode(): ?TimeCode {
    return this._timecode;
  }

  setTimeCode(time: TimeCode) {
    this._timecode = time;
  }
  getAiType(): string {
    return this._assetAiDataModel.getAiType();
  }
}

class BoundingBoxImpl extends BoundingBox {
  _points: Array<Point>;
  constructor(points: Array<Point>) {
    super();
    this._points = points.map(this.fixPrecision);
  }

  fixPrecision(point: Point): Point {
    point.setX(point.getX() / 1000);
    point.setY(point.getY() / 1000);
    return point;
  }

  getPoints(): Array<Point> {
    return this._points;
  }
}

class GroupByClass {
  _assetAiDatas: AssetAiDataWebclient[];
  //_groupName2DocumentIds: Map<string, Array<string>>;
  _idToAssetAiData: Map<string, AssetAiData>;
  _groupNameToDocumentIds: Map<string, Array<string>>;

  constructor(assetAiData: AssetAiDataWebclient[], groupNameToDocumentIds: Map<string, Array<string>>) {
    this._assetAiDatas = assetAiData;
    this._groupNameToDocumentIds = groupNameToDocumentIds;
    //this._groupName2DocumentIds = new Map();
    this._idToAssetAiData = new Map();
    this.processArray();
  }

  processArray() {
    for (let index = 0; index < this._assetAiDatas.length; index++) {
      const element = this._assetAiDatas[index];
      this._idToAssetAiData.set(element.getUuid(), new AssetAiDataImpl(element));
    }
    //for (const aiData: AssetAiDataWebclient of this._assetAiDatas) {
    //const aiType: AiType = this.getType(aiData);
    //this.addToAiTypeToDocumentsIdsMap(aiType, aiData);
    //      this._idToAssetAiData.set(aiData.getUuid(), new AssetAiDataImpl(aiData));
    //  }
  }

  /*  addToAiTypeToDocumentsIdsMap(aiType: AiType, aiData: AssetAiDataWebclient) {
    let documentIds: ?Array<string> = this._groupName2DocumentIds.get(aiType.name);
    if (!documentIds) {
      documentIds = [];
      this._groupName2DocumentIds.set(aiType.name, documentIds);
    }
    documentIds.push(aiData);
  }

  getType(aiData: AssetAiDataWebclient): AiType {
    return AiType.toEnum(aiData.getAiType());
  } */
}

export class AssetAiKeyframeMetaData {
  _timecode: ?TimeCode;
  _value: ?string;
  _properties: ?Map<string, string>;

  constructor(assetAiKeyFrameData: AssetAiDataWebclient[]) {
    if (assetAiKeyFrameData.startTimeMs == 0 || assetAiKeyFrameData.startTimeMs) {
      this._timecode = new TimeCode(assetAiKeyFrameData.startTimeMs, assetAiKeyFrameData.stopTimeMs);
    }
    this._value = assetAiKeyFrameData.value;
  }

  getTimeCode(): ?TimeCode {
    return this._timecode;
  }

  getValue(): ?string {
    return this._value;
  }

  getProperties(): ?Map<string, string> {
    return this._properties;
  }

  forEachProperty(callback: (propertyName: string, propertyValue: string, index: number) => void): void {
    let index: number = 0;
    if (this.getValue() != null) {
      const v = this.getValue();
      if (v) callback('value', v, index++);
    }

    // if (this.getConfidence() > 0) {
    //   callback('confidence', this.getConfidence() + '%', index++);
    // }

    const props: ?Map<string, string> = this.getProperties();
    if (props) {
      props.forEach(function(v: string, k: string) {
        callback(k, v, index++);
      });
    }
  }
}
